<template>
  <div class="filial-settings-field">
    <label class="filial-settings-field__label">
      <span>{{ label }}</span>
    </label>

    <loader v-if="loading || localLoading" :fixed="false" :absolute="false" />

    <template v-else>
      <div v-for="(group, groupKey) in settings" :key="`brsetgroup-${groupKey}`" class="filial-settings-field__group">
        <div class="text-h3 filial-settings-field__group-title" v-text="getGroupTitle(groupKey)" />
        <v-row v-for="(v, i) in group" :key="`brsetrow-${i}`">
          <v-col cols="9">
            <template v-if="v.type === 'boolean'">
              <v-checkbox
                v-if="v.isDefaultValue"
                v-model="v.defaultValue"
                :label="v.name"
                disabled
              />
              <v-checkbox
                v-else
                v-model="v.value"
                :label="v.name"
                outlined
                :disabled="v.isDefaultValue || disabled"
                @input="emitInput"
              />
            </template>

            <template v-else-if="v.type === 'payment_methods_table'">
              <div class="text-subtitle-1 mb-2">
                {{ v.name }}
              </div>
              <payment-by-delivery-relation-settings
                v-show="v.isDefaultValue"
                :value="v.defaultValue"
                :online-payment-enabled="onlinePaymentEnabled"
                disabled
              />
              <payment-by-delivery-relation-settings
                v-show="!v.isDefaultValue"
                v-model="v.value"
                :online-payment-enabled="onlinePaymentEnabled"
                :disabled="v.isDefaultValue || disabled"
                @input="emitInput"
              />
            </template>

            <template v-else-if="v.type === 'printer_code_pages_table'">
              <printer-code-pages-settings
                v-show="v.isDefaultValue"
                :value="v.defaultValue"
                :label="v.name"
                disabled
              />
              <printer-code-pages-settings
                v-show="!v.isDefaultValue"
                v-model="v.value"
                :label="v.name"
                :disabled="v.isDefaultValue || disabled"
                @input="emitInput"
              />
            </template>

            <template v-else>
              <v-text-field
                v-show="v.isDefaultValue"
                v-model="v.defaultValue"
                :label="v.name"
                outlined
                disabled
              />
              <v-text-field
                v-show="!v.isDefaultValue"
                v-model="v.value"
                value=""
                :label="v.name"
                outlined
                :disabled="v.isDefaultValue || disabled"
                @input="emitInput"
              />
            </template>
          </v-col>
          <v-col cols="3">
            <v-switch
              :input-value="!v.isDefaultValue"
              :label="`Переопределить`"
              :disabled="disabled"
              @change="v.isDefaultValue=!v.isDefaultValue"
            />
          </v-col>
        </v-row>
      </div>
    </template>

    <template>
    </template>
  </div>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import Loader from '@/components/loader/Loader'
  import PaymentByDeliveryRelationSettings from './filial-settings/PaymentByDeliveryRelationSettings.vue'
  import PrinterCodePagesSettings from './filial-settings/PrinterCodePagesSettings.vue'
  import _ from 'lodash'

  export default {
    name: 'FilialSettingsField',
    components: { Loader, PaymentByDeliveryRelationSettings, PrinterCodePagesSettings },
    mixins: [snackbarMessage],
    props: {
      value: Array,
      label: {
        type: String,
        default: 'Настройки...',
      },
      createEntity: { // true в форме создания сущности
        type: Boolean,
        default: false,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        localLoading: false,
      }
    },
    computed: {
      settings () {
        const sortedSettings = _.sortBy(this.value, ['group', 'sort'])
        return _.groupBy(sortedSettings, 'group')
      },
      onlinePaymentEnabled () {
        const setting = this.value.find(s => s.key === 'onlinePaymentEnabled')
        if (!setting) return true // По умолчанию считаем включенным, если настройки нет

        // Проверяем значение: если переопределено - берем value, иначе defaultValue
        const val = setting.isDefaultValue ? setting.defaultValue : setting.value

        // Значение может быть строкой "1"/"0", числом 1/0 или булевым
        return val === 1 || val === 'true' || val === true
      },
    },
    created () {
      if (this.createEntity) {
        this.loadDefaultSettings()
      }
    },
    methods: {
      getGroupTitle (groupKey) {
        if (groupKey && groupKey !== 'null') {
          return this.value.find((item) => item.group === groupKey)?.groupTitle || groupKey
        }
        return 'Разное'
      },
      getInputValue (row) {
        return row.isDefaultValue ? row.defaultValue : row.value
      },
      onChangeSwitch (row) {
        row.isDefaultValue = !row.isDefaultValue
        this.emitInput()
      },

      emitInput () {
        this.$emit('input', this.value)
      },
      async loadDefaultSettings () {
        this.localLoading = true
        try {
          let settings = await this.$store.dispatch('branchesSettings/fetchSettings', {
            limit: 10000,
            offset: 0,
            page: 1,
          })

          settings = settings.filter((item) => {
            return item.system !== true
          })

          this.$emit('input', settings)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.localLoading = false
      },
    },
  }
</script>

<style lang="less" scoped>
.filial-settings-field {
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.38);
  position: relative;
  margin-bottom: 50px;

  &__label {
    position: absolute;
    top: 11px;
    left: -12px;
    background: white;
    padding: 0 5px;
    transform: translateY(-24px) scale(0.75);
    color: #999999;
    font-size: 16px;
  }

  &__group-title {
    color: #000;
    margin-bottom: 10px;
    //font-weight: 400;
  }

  &__group {
    margin-bottom: 20px;
   // border-bottom: 1px solid #c5c5c5;

    &:last-child {
      margin-bottom: 0;
      border-bottom: none;
    }
  }
}
</style>
